<template>
  <div id="password-reset">
    <WaveBg />

    <div class="content">
      <EmailForm v-if="!sent" :error="error" @send="sendEmail" />
      <EmailSent v-else />
    </div>

    <HUBLoader v-if="isLoading" />
  </div>
</template>

<script>
import EmailForm from './EmailForm.vue';
import EmailSent from './EmailSent.vue';

import WaveBg from '@/components/common/WaveBackground.vue';
import HUBLoader from '@/components/common/hubLoading.vue';

export default {
  name: 'PasswordReset',

  data() {
    return {
      isLoading: false,
      sent: false,
      error: '',
    };
  },

  methods: {
    async sendEmail(email) {
      this.error = '';
      this.isLoading = true;

      try {
        await this.$api.patch('/password/apply', { email });
        this.sent = true;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    WaveBg,
    HUBLoader,
    EmailForm,
    EmailSent,
  },
};
</script>

<style scoped>
#password-reset {
  width: 100%;
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  padding: 2em 1.5em;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .content {
    padding: 2em 3em;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .content {
    padding: 2em 3em;
  }
}
</style>
